import {formatStringToFloatDecimalCase} from "../../../../utils/format-decimal"

export const formatValue = (params, minimum, maximum) => {
    const {value} = params
    if (value === "") {
        return null
    }

    return formatStringToFloatDecimalCase(value, minimum, maximum)
}

export const renderCellWithTooltip = (params) => {
    const {value} = params

    return (
        // eslint-disable-next-line react/react-in-jsx-scope
        <div title={value}>
            {value}
        </div>
    )
}
